export const TXTCLI_Please_try_againX = {
  "id": "TXTCLI_Please_try_againX",
  "defaultMessage": "Please try again."
} as const;

export const TXTCLI_The_SSN_that_you_have_entered__ELL = {
  "id": "TXTCLI_The_SSN_that_you_have_entered__ELL",
  "defaultMessage": "The SSN that you have entered does not match the SSN that you previously entered."
} as const;